module.exports = __webpack_public_path__ + "static/media/liushishishan_package.7646ecc1.png";